import { Typography, Row, Divider, Input } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import { Question, StepIndex } from '../../../constants/question';
import useMobile from '../../../hooks/useMobile';
import { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import './OhatCheckQuestionRow.css';

const { Title } = Typography;

type Props = {
  onSelect: (step: StepIndex, answerIndex: number) => void;
  question: Question;
  answer: number;
  step: StepIndex;
  innerRef: Ref<HTMLDivElement>;
  /** 項目別メモ（ライトプラン限定）。showMemo が false のときは非表示。 */
  showMemo?: boolean;
  memo?: string;
  onMemoChange?: (step: StepIndex, value: string) => void;
  /** メモ欄のラッパー要素への参照（選択後のスクロール先に使う） */
  memoRef?: Ref<HTMLDivElement>;
};
export default function OhatCheckQuestionRow(props: Props) {
  const {
    onSelect,
    question,
    answer,
    step,
    innerRef,
    showMemo,
    memo,
    onMemoChange,
    memoRef,
  } = props;
  const { isMobile } = useMobile();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div ref={innerRef} style={{ cursor: 'pointer' }}>
      <Title level={isMobile() ? 3 : 2}>{`Q${step + 1}. ${question.getLabel(
        lang,
      )}`}</Title>
      <Divider />
      {Array.from({ length: 3 }).map((_, idx) => (
        <div key={idx}>
          <Row
            gutter={[0, 0]}
            key={idx}
            onClick={() => onSelect(step, idx)}
            className="question-row"
          >
            <div className="question-wrapper">
              <div
                className={
                  answer === idx ? 'question-label-selected' : 'question-label'
                }
              >
                <div>{question.choices[idx].status.getLabel(lang)}</div>
                <div className="question-score-label">
                  {`${t('ohat.scoreLabel')} ${question.choices[idx].status.score}`}
                </div>
              </div>
              <div className={'question-description'}>
                {question.choices[idx].getDescription(lang).map((v, i) => (
                  <span key={i} className="question-text">{`${v}`}</span>
                ))}
              </div>
            </div>
            <div className="question-img-container">
              <img
                alt={'ohat'}
                src={question.choices[idx].imageSrc}
                className="question-img"
              />
            </div>
          </Row>
          <Divider />
        </div>
      ))}
      {showMemo && (
        <div
          ref={memoRef}
          style={{
            margin: '4px 0 32px',
            padding: '6px 10px',
            background: '#fafafa',
            border: '1px solid #d9d9d9',
            borderRadius: 8,
          }}
        >
          <Typography.Text
            type="secondary"
            style={{
              fontSize: 12,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <FormOutlined />
            {t('ohat.memoOptionalFor', { label: question.getLabel(lang) })}
          </Typography.Text>
          <Input.TextArea
            value={memo ?? ''}
            onChange={(e) => onMemoChange?.(step, e.target.value)}
            maxLength={500}
            variant="borderless"
            autoSize={{ minRows: 1, maxRows: 3 }}
            placeholder={t('ohat.memoPlaceholder')}
            style={{ paddingLeft: 0, paddingRight: 0 }}
          />
        </div>
      )}
    </div>
  );
}
